import React from "react";
import Seo from "../components/Seo";
import "../styles/pages/service-detail.css";

function DomiciliaryCare() {
    return (
        <main className="page">
            <Seo
                title="Domiciliary Care Including Live-In"
                path="/services/domiciliary-care"
                description="Flexible domiciliary care and live-in support services that help people remain safe, comfortable, and independent in their own homes."
                keywords="domiciliary care, live-in care, home care services, personal care support, companionship support"
            />

            <div className="container service-detail">
                <div className="service-hero-card">
                    <p className="eyebrow">Domiciliary Care</p>
                    <h1>Thoughtful home-based support that promotes dignity and independence</h1>
                    <p>
                        We offer flexible home-based support that helps people remain comfortable, safe, and independent in familiar surroundings.
                    </p>
                </div>
                <div className="detail-grid detail-grid--three">
                    <div className="info-card"><h2>Personal Care</h2><p>Support with daily living, routines, and practical needs.</p></div>
                    <div className="info-card"><h2>Companionship</h2><p>Meaningful social support and wellbeing-focused visits.</p></div>
                    <div className="info-card"><h2>Live-In Support</h2><p>Ongoing care for individuals who need round-the-clock assistance.</p></div>
                </div>
            </div>
        </main>
    );
}

export default DomiciliaryCare;